import { render, staticRenderFns } from "./SettingsUserPermissions.vue?vue&type=template&id=d805aa7c&scoped=true&"
import script from "./SettingsUserPermissions.vue?vue&type=script&lang=js&"
export * from "./SettingsUserPermissions.vue?vue&type=script&lang=js&"
import style0 from "./SettingsUserPermissions.vue?vue&type=style&index=0&id=d805aa7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d805aa7c",
  null
  
)

export default component.exports